import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'empty' })
export class EmptyPipe implements PipeTransform {
  transform(value: any, replacer?: string): any {
    return value ? value : replacer ? replacer : '-';
  }
}
